module.exports = __webpack_public_path__ + "static/safe-min-54c049dc2e42db4cc08b863ffbd529c6.jpg";